/* eslint-disable import/prefer-default-export */
import { useSelector } from 'react-redux';

interface UserInfo {
  firstname?: string;
  lastname?: string;
}

interface RootState {
  user?: {
    userInfo?: UserInfo;
  };
}

/**
 * Hook to get the current user's display name (first name + last name)
 *
 * In production (host app): Gets data from Redux store
 * In local development: Returns mock data based on REACT_APP_ROLES_LOCAL_DEV env var
 *
 * @returns User's full display name as a string
 */
export const useUserDisplayName = (): string => {
  const userInfo =
    useSelector((state: RootState) => state.user?.userInfo) ?? {};

  // Local development: return mock data
  if (process.env.REACT_APP_ROLES_LOCAL_DEV) {
    return 'Jane Doe';
  }

  // Production/loopback: use Redux data
  const displayName = `${userInfo.firstname ?? ''} ${
    userInfo.lastname ?? ''
  }`.trim();

  return displayName;
};
